export default __webpack_public_path__ + "signing-picture.png";